export const language = {
	field: '',
	backButtonLabel: 'Back to Portfolio',
	backButtonIcon: 'arrow-left',
	nextButtonLabel: 'Next Use Case',
	nextButtonIcon: 'arrow-right',
	previousButtonLabel: 'Previous Use Case',
	previousButtonIcon: 'arrow-left',
};
